<template>
  <div class="rs-segment-info">
    <!-- In the query-overview layout the save-as prompt lives in
         unsaved-changes-alert.vue; the partner-section flow keeps its
         update link here. -->
    <div
      v-if="
        (!segment || !segment.id) &&
        (partnerSegmentName || !queryOverviewEnabled)
      "
      class="sf-bg-warning-subtle-2 tw-p-4"
      :class="
        inFloatingSidepane
          ? 'tw-border-0 tw-border-b tw-border-solid tw-border-sf-slate-lighter-1'
          : 'sf-layer-border-bottom'
      "
    >
      <SfButtonDs v-if="!partnerSegmentName" @click="openSaveSegmentModal">
        <span class="fa fa-pie-chart sf-c-primary tw-mr-1"></span>
        <span>{{ I18n.t('companies_overview.segments_new.save_as') }}</span>
      </SfButtonDs>

      <SfButtonDs
        v-if="partnerSegmentName"
        data-testid="update-partner-segment"
        @click="updatePartnerSegment(partnerSegmentID)"
      >
        <span class="fa fa-pie-chart sf-c-primary tw-mr-1"></span>
        <span>Update "{{ partnerSegmentName }}" in Partner Section</span>
      </SfButtonDs>
    </div>

    <!-- In the query-overview layout this lives in unsaved-changes-alert.vue -->
    <div
      v-if="isSegmentModified && !queryOverviewEnabled"
      class="sf-bg-warning-subtle-2 tw-p-4"
      :class="
        inFloatingSidepane
          ? 'tw-border-0 tw-border-b tw-border-solid tw-border-sf-slate-lighter-1'
          : 'sf-layer-border-bottom'
      "
    >
      <div class="sf-text sf-c-warning sf-below-3">
        {{ I18n.t('companies_overview.segments_new.filters_have_changed') }}
      </div>
      <div class="sf-level sf-level-vertical sf-level-small">
        <div class="sf-level-item">
          <div
            v-if="canUpdateSegment && (!segment || !segment.recommended)"
            v-tooltip="
              marketSegment
                ? I18n.t(
                    'companies_overview.segments_new.market_segment_cannot_save'
                  )
                : ''
            "
            class="sf-inline-block"
          >
            <SfButtonDs
              :disabled="marketSegment"
              class="rs-update-segment"
              @click="updateSegmentWithConfirm"
            >
              <span
                class="
                  fa fa-solid fa-triangle-exclamation
                  sf-c-warning-light-1
                  tw-mr-1
                "
              ></span>
              <span>{{
                I18n.t('companies_overview.segments_new.update')
              }}</span>
            </SfButtonDs>
          </div>
        </div>

        <div class="sf-level-item rs-create-segment">
          <SfButtonDs @click="openSaveAsSegmentModal">
            <span class="fa fa-pie-chart sf-c-primary tw-mr-1"></span>
            <span>{{
              I18n.t('companies_overview.segments_new.save_as_new')
            }}</span>
          </SfButtonDs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState as mapPiniaState, mapActions as mapPiniaActions } from 'pinia'
import { useSegmentsStore } from '@app/insights/store/segments'
import { useInsightsRootStore } from '@app/insights/store/insights-root'
import { INSIGHTS_LAYOUT_CONTEXT_KEY } from '@app/insights/composables/use-insights-layout-context'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

export default {
  components: { SfButtonDs },
  inject: {
    insightsLayoutContext: {
      from: INSIGHTS_LAYOUT_CONTEXT_KEY,
      default: () => ({ inFloatingSidepane: false }),
    },
  },

  computed: {
    inFloatingSidepane() {
      return this.insightsLayoutContext.inFloatingSidepane
    },
    ...mapPiniaState(useSegmentsStore, ['segment', 'isSegmentModified']),
    ...mapPiniaState(useInsightsRootStore, ['lite', 'queryOverviewEnabled']),

    marketSegment() {
      return !!this.segment.partner
    },

    partnerSegmentID() {
      return this.$route.query.ms_id
    },

    partnerSegmentName() {
      return this.partnerSegmentID && this.$route.query.ms_name
    },
    canUpdateSegment() {
      return this.segment?.permissions.update
    },
  },
  methods: {
    ...mapPiniaActions(useSegmentsStore, [
      'openSaveSegmentModal',
      'openSaveAsSegmentModal',
      'updateSegment',
      'updatePartnerSegment',
    ]),

    updateSegmentWithConfirm() {
      if (this.marketSegment) return
      window.sfConfirm({
        question: I18n.t('companies_overview.segments_new.confirm_update'),
        onConfirm: async () => {
          try {
            await this.updateSegment()
          } catch (e) {
            alert(e.body.errorMessage)
          }
        },
      })
    },
  },
}
</script>
